import React from "react";
import Typography from "apollo-react/components/Typography";
import Box from "apollo-react/components/Box";
import styles from "./ReviewItem.module.css";

const ReviewItem = ({ review }) => {
  const date = new Date(review.createdAt);
  const formattedDate = date.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
  const formattedTime = date.toLocaleTimeString("en-US", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });

  // Determine the CSS class based on review status
  const getReviewClass = (status) => {
    switch (status) {
      case "approved":
        return styles.approved;
      case "rejected":
      case "declined":
        return styles.rejected;
      default:
        return styles.default;
    }
  };

  const reviewClass = getReviewClass(review.review);

  // Extract user information with fallbacks
  const username = review?.User?.username ||
    review?.end_user?.username ||
    review?.member?.username ||
    `Member ${review.member_id}`;

  const email = review?.User?.email ||
    review?.end_user?.email ||
    review?.member?.email ||
    null;

  return (
    <div className={styles.reviewItem}>
      <Box
        sx={{
          paddingBottom: 2,
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 2,
            marginBottom: 1,
            flexWrap: "wrap",
            justifyContent: "space-between",
          }}
        >
          <Box sx={{ display: "flex", flexDirection: "row", gap: 1, alignItems: "baseline" }}>
            <Typography
              sx={{
                fontFamily: "Proxima Nova",
                fontWeight: 700,
                fontStyle: "bold",
                fontSize: "17px",
                lineHeight: "20px",
                letterSpacing: 0,
              }}
            >
              {username}
            </Typography>
            <Typography sx={{ fontFamily: "Proxima Nova", fontStyle: "regular", fontWeight: 400, fontSize: "15px", lineHeight: "20px", color: "#666", letterSpacing: 0 }}>
              {review?.end_user?.end_users_category?.name}
            </Typography>
          </Box>
          <Typography sx={{ color: "#999", fontWeight: 500, fontSize: "12px", lineHeight: "18px", letterSpacing: 0 }}>
            {formattedDate} -{" "}
            {formattedTime}
          </Typography>

        </Box>
        {email && (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              width: "fit-content",
              marginBottom: 1.5,
            }}
          >
            <Typography
              variant="body2"
              sx={{
                color: "#000",
                fontWeight: 400,
                fontSize: "14px",
                lineHeight: "140%",
                letterSpacing: 0,
              }}
            >
              {email}
            </Typography>
          </Box>
        )}

        {review.rejection_reason && (
          <div className={styles.rejectionReasonContainer}>
            <Typography variant="bodysmall" className={styles.rejectionReasonLabel}>
              Rejection Reason: {
                <span className={styles.rejectionReasonDescription}>
                  {review.rejection_reason}
                </span>}
            </Typography>
            {/* <Typography variant="bodyDefault" className={styles.rejectionReasonDescription}>
              {review.rejection_reason}
            </Typography> */}
          </div>
        )}
      </Box>
    </div>
  );
};

export default ReviewItem; 